import React from 'react'
import Hero from './sections/Hero'
import Features from './sections/Features';
import About from './sections/About';
import Plans from './sections/Plans';
import Subscribe from './sections/Subscribe';
import Blog from './sections/Blog';
import Footer from './sections/Footer';

const App = () => {
  return (
    <>
      <Hero />
      <Features />
      <About />
      <Plans />
      <Subscribe />
      <Blog />
      <Footer />
    </>
  );
}

export default App;
